import apiClient from './api'
import { STORAGE_KEYS } from '@/config/env'
import { AuthUser, LoginPayload, LoginResponse, Verify2FAPayload } from '@/types/auth'

export const authService = {
  async login(payload: LoginPayload): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/auth/login', payload)
    // Only store token if 2FA is not required
    if (!data.requires2FA && data.accessToken && typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.authToken, data.accessToken)
      if (data.refreshToken) {
        localStorage.setItem(STORAGE_KEYS.refreshToken, data.refreshToken)
      }
    }
    return data
  },

  async verify2FA(payload: Verify2FAPayload): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/auth/verify-2fa', payload)
    if (data.accessToken && typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.authToken, data.accessToken)
      if (data.refreshToken) {
        localStorage.setItem(STORAGE_KEYS.refreshToken, data.refreshToken)
      }
    }
    return data
  },

  async sendTestCode(email: string): Promise<{ message: string; userId: string }> {
    const { data } = await apiClient.post<{ message: string; userId: string }>('/auth/send-test-code', { email })
    return data
  },

  async toggle2FA(enable: boolean): Promise<{ message: string; twoFactorEnabled: boolean }> {
    const { data } = await apiClient.post('/auth/toggle-2fa', { enable })
    return data
  },

  async currentUser(): Promise<AuthUser | null> {
    const { data } = await apiClient.get<AuthUser>('/auth/me')
    return data
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout')
    if (typeof window !== 'undefined') {
      localStorage.removeItem(STORAGE_KEYS.authToken)
      localStorage.removeItem(STORAGE_KEYS.refreshToken)
    }
  },
}


